import React from 'react'
import '../../../stylesheets/ControllerDashboard.css'
import Loader from 'react-loader-spinner'
import {transferControllerID} from "../../../api"
import DatePicker from 'react-datepicker';
import '../../../stylesheets/Controllers.css'
import 'react-datepicker/dist/react-datepicker.css';
import { UserConfirmationRequest} from '../../../models'
import {pageHelpers} from '../'

import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import { Button, Label, Row, Col} from 'reactstrap'


class TransferController extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token} = props
        this.state = {
            token,
            fromDate: null,
            toDate: null,
            fromPhone:'',
            toPhone:'',
            loading:false,
            userConfirmationRequests: [],
 
            
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.dismissUserConfirmationRequest = this.dismissUserConfirmationRequest.bind(this)
    }
    handleValidSubmit(event, values) {
        event.preventDefault()
    
        let {fromPhone, toPhone} = values
        let{fromDate, toDate, loading} =this.state
        if(fromDate == null || toDate == null){
            let confirm = async () =>{
                this.setState({userConfirmationRequests: []})
            }
            let request = new UserConfirmationRequest('Transfer Controller',
            `Please Select date range`,confirm,
            this.dismissUserConfirmationRequest)
            this.setState({userConfirmationRequests: [request] })
        }else{
            this.setState({loading: true})
            let concatdate= new Date(fromDate)
            let sday= ("0" + (concatdate.getMonth() + 1)).slice(-2)
            let newFromDate= concatdate.getFullYear()+'-'+sday+'-'+concatdate.getDate()
            let concatToDate= new Date(toDate)
            let eday= ("0" + (concatToDate.getMonth() + 1)).slice(-2)
            let new_day = parseInt(concatToDate.getDate())+1
            let newToDate= concatToDate.getFullYear()+'-'+eday+'-'+new_day
            this.submitForm(newFromDate, newToDate, fromPhone, toPhone)
        }
    }
    dismissUserConfirmationRequest() {
        this.setState({userConfirmationRequests: [], loading: false})
    }
    
    async submitForm(fromDate, toDate, fromPhone, toPhone){
        let {token} = this.state
        let result = await transferControllerID(fromDate, toDate, fromPhone, toPhone, token)
        let confirm = async () =>{
            this.setState({userConfirmationRequests: []})
        }
        if(result.error){
            let request = new UserConfirmationRequest('Transfer Controller',
            `${result.error}`,confirm,
            this.dismissUserConfirmationRequest)
            
        await this.setState({userConfirmationRequests: [request],
                            
                            fromPhone: fromPhone,
                            toPhone: toPhone
                            })
        
        this.setState({loading: false})
        } else{
            let request = new UserConfirmationRequest('Transfer Controller',
            `${result.success}`,confirm,
            this.dismissUserConfirmationRequest)
        await this.setState({userConfirmationRequests: [request],
                            fromDate: '',
                            toDate: '',
                            fromPhone: '',
                            toPhone: ''
        })
        
        this.setState({loading: false})
        }

    }
    onChange = date => this.setState({toDate: date })
    fromChange = date => this.setState({fromDate: date })
    render() {
        let{toDate, fromDate, fromPhone, userConfirmationRequests, loading} = this.state
        const checkOutValidationMessage ='Date is required'

        return (<div>
             <br />
            <br />
            <h1 className="col-12">Transfer Controller Data</h1>
            <br />
            {loading ?
                    <Col xs={12} className="text-center m-4">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </Col> :
            <AvForm onValidSubmit={this.handleValidSubmit}    onInvalidSubmit={pageHelpers.handleInvalidFormSubmit} model={this.state} className="text-left col-12 col-sm-10 col-md-8 col-lg-6 offset-0 offset-sm-1 offset-md-2 offset-lg-3 no-gutters">
            <AvGroup>
                <Label for="teamName">From Serial Number</Label>
                <AvInput placeholder="Enter the Serial Number"
                          type="text"
                          name="fromPhone"
                          minLength={10}
                          required={true}/>
                <AvFeedback>Please enter a valid serial number(atleast 10-digits).</AvFeedback>
            </AvGroup>
            <AvGroup>
                <Label for="teamName">To Serial Number</Label>
           
                           <AvInput placeholder="Enter the Serial Number"
                           type="text"
                           name="toPhone"
                           minLength={10}
                           required={true}/>
                 <AvFeedback>Please enter a valid serial number(atleast 10-digits).</AvFeedback>
            </AvGroup>
                <Label for="teamName">From Date</Label>
                <div className="col-lg-8" >
                <DatePicker style={{ maxWidth: 250 }}
                    name="fromDate"
                    onChange={this.fromChange}
                    placeholderText="MM-DD-YYYY"
                    dateFormat="MM-DD-YYYY"
                    selected = {fromDate}
                    autocomplete="off"
                />
                </div>
                <Label for="teamName">To Date</Label>
                <Row>
                <div className="customDatePickerWidth col-lg-8" style={{width:500}}>
                <DatePicker style={{ maxWidth: 250 }} name ="toDate"
                    onChange={this.onChange}
                    placeholderText="MM-DD-YYYY"
                    dateFormat="MM-DD-YYYY"
                    selected = {toDate}
                    required = {true}
                    validationMessage={checkOutValidationMessage}
                    autocomplete="off"
                />
                </div>
            </Row>
            <Button className="mt-3">Transfer Info</Button>
            </AvForm>
            }
        
        {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}
         
        </div>)
    }
}

export default TransferController



// WEBPACK FOOTER //
// ./src/components/pages/controllers/TransferController.js